@if (isInFocus()) {
  <div
    class="search-bar-overlay"
    (click)="handleSearchBarInFocus(false)"
  >
    <i class="mbi mbi-cross search-bar-overlay-close"></i>
  </div>
}

<div
  class="search-bar"
  [class.search-bar-in-focus]="isInFocus()"
  (clickOutside)="handleSearchBarInFocus(false)"
>
  <input
    class="search-bar-input"
    [formControl]="searchControl"
    (focus)="handleSearchBarInFocus(true)"
    type="text"
    [title]="'search_bar.search' | translate"
    [placeholder]="'search_bar.search' | translate"
    #inputRef
  >

  @if (isInFocus() && searchControl.value) {
    <button
      class="search-bar-clear"
      (click)="clearInput()"
      type="button"
    >
      <i class="mbi mbi-cross search-bar-clear-icon"></i>
    </button>
  }

  <a
    #searchLink
    class="g-btn search-bar-btn"
    [routerLink]="searchLinkCommands"
    [queryParams]="searchLinkQueryParams"
    (click)="onSearchClick($event)"
  >
    {{ 'search_bar.find' | translate }}
  </a>

  @if (isInFocus() && (searchResults() || searchError() || isSearchInProgress())) {
    <div class="search-bar-results">
      @if (isSearchInProgress()) {
        <preloader class="search-bar-preloader" />
      } @else {
        @if (searchError(); as error) {
          <div class="search-bar-error">{{ error }}</div>
        }
        @if (searchResults()) {
          @if (!searchResults().length) {
            <div class="search-bar-no-result">
              {{ 'search_bar.nothing_found' | translate }}
            </div>
          }
          @for (item of searchResults(); track item.slug; let indexOfProduct = $index) {
            <a
              #resultLink
              class="search-bar-result search-bar-result-item"
              [class.search-bar-result-active]="indexOfProduct === activeIndex()"
              [routerLink]="['/', item.slug]"
              routerLinkWithLang
            >
              @if (item.type !== autocompleteItemTypes.Category) {
                <img
                  class="search-bar-result-img"
                  [src]="getResultImage(item)"
                  loading="lazy"
                  [alt]="item.name"
                >
              }
              <div
                class="search-bar-result-name"
                [class.search-bar-result-name-category]="item.type === autocompleteItemTypes.Category"
              >
                @if (item.type === autocompleteItemTypes.Category) {
                  <span class="search-bar-result-pretext">
                    {{ 'search_bar.go_to_category' | translate }}:
                  </span>
                }
                {{ item.name }}
              </div>
            </a>
          }
        }
      }
    </div>
  }
</div>
